<template>
  <div>
    <FilterCard :applied-filter-count="appliedFilterCount">
      <b-row>
        <b-col
          cols="12"
          md="3"
        >
          <b-form-group
            label="Assigned Date"
            label-for="v-ref-no"
          >
            <div class="position-relative">
              <AdvancedDateFilter
                :date-value="filters['order_status_key_5.created_at']"
                :opens="'right'"
                :clear-icon="false"
                @update="updateDateRange('order_status_key_5.created_at', $event)"
              />
            </div>
          </b-form-group>
        </b-col>
        <b-col
          cols="12"
          md="3"
        >
          <b-form-group
            label="Rider"
            label-for="rider"
          >
            <v-select
              v-model="filters['staff.id']"
              :options="riderOptions"
              :reduce="option => option.id"
              label="first_name"
              placeholder="Select Rider"
            >
              <template v-slot:option="option">
                {{ option.reference_id }} | {{ option.first_name }} {{ option.last_name }}
              </template>
            </v-select>
          </b-form-group>
        </b-col>
      </b-row>
      <!-- Apply and Clear Filters -->
      <b-row class="mt-1">
        <b-col>
          <filter-buttons
            :filter-data="filters"
            :apply-filters="applyFilters"
            :clear-filters="clearFilters"
          />
        </b-col>
      </b-row>
    </FilterCard>
    <div>
      <div>
        <b-card
          no-body
        >
          <div
            class="m-2"
          >
            <b-row>
              <b-col
                class="d-flex align-items-center justify-content-end mb-1 mb-md-0"
              >
                <div>
                  <ReportTableButtons
                    :items="items"
                    :json_fieldz="json_fields"
                    :name="`${downloadReportName} - Page ${page}.xls`"
                    :bulkname="`${downloadReportName}.xls`"
                    :fetch="fetchAssignOrderPickupRiderNoPagination"
                    :use-queue-download="true"
                    @refresh="fetchAssignOrderPickupRider"
                    @queue-download="downloadQueueExcel"
                  />
                </div>
              </b-col>
            </b-row>
          </div>
          <b-overlay
            id="overlay-background"
            blur="10px"
            opacity="0.30"
            rounded="sm"
            variant="light"
          >
            <b-table
              striped
              hover
              responsive
              :per-page="perPage"
              :items="items"
              :fields="fields"
              :json_fields="json_fields"
              :sort-by.sync="sortBy"
              :sort-desc.sync="sortDesc"
              :sort-direction="sortDirection"
              show-empty
              sticky-header="100vh"
              @sort-changed="sortChanged"
            >
              <template #empty>
                <TableDataFetching
                  :rows="items"
                  :data-loading="dataLoading"
                />
              </template>
              <template #head()="{ field }">
                <div
                  class="sortable-header"
                >
                  <span class="header-text">{{ field.label }}</span>
                  <feather-icon
                    v-if="field.sortable"
                    :icon="sort === field.key
                      ? 'ArrowUpIcon'
                      : 'ArrowDownIcon'"
                    size="14"
                  />
                </div>
              </template>
              <template #cell(assign_date)="data">
                {{ __dateTimeFormatter(data.value) }}
              </template>
              <template #cell(customer_phone)="data">
                <div>{{ data.item.customer_phone }}</div>
                <div>{{ data.item.customer_secondary_phone }}</div>
              </template>
              <template #cell(cod_value)="data">
                {{ __numberWithCommas(data.value, true) }}
              </template>
              <template #cell(rider)="data">
                <div class="d-flex align-items-center width-100">
                  <div>
                    <div class="font-weight-bolder">
                      {{ data.item.rider ? data.item.rider : 'N/A' }}
                    </div>
                    <div class="font-small-2">
                      {{ data.item.rider_employee_id ? data.item.rider_employee_id : '' }}
                    </div>
                  </div>
                </div>
              </template>
            </b-table>
          </b-overlay>
          <div class="mx-2 mb-2">
            <b-row>
              <b-col
                cols="12"
                md="3"
                class="d-flex align-items-center justify-content-sm-start"
              >
                <label class="mr-1">Per page</label>
                <v-select
                  v-model="perPage"
                  :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                  :options="pageOptions"
                  :clearable="false"
                  class="per-page-selector d-inline-block width-125"
                />
              </b-col>
              <!-- Pagination -->
              <b-col
                cols="12"
                md="9"
                class="d-flex align-items-center justify-content-sm-end"
              >
                <span class="text-muted pagination-text  mt-1 mt-md-0 mr-1">Showing {{ meta.from }} to {{ meta.to }} of {{ meta.total }} entries</span>
                <b-pagination
                  v-model="page"
                  :total-rows="(meta.total)? meta.total : 0"
                  :per-page="perPage"
                  first-number
                  last-number
                  class="mb-0 mt-1 mt-sm-0"
                  prev-class="prev-item"
                  next-class="next-item"
                >
                  <template #prev-text>
                    <feather-icon
                      icon="ChevronLeftIcon"
                      size="18"
                    />
                  </template>
                  <template #next-text>
                    <feather-icon
                      icon="ChevronRightIcon"
                      size="18"
                    />
                  </template>
                </b-pagination>

              </b-col>
            </b-row>
          </div>
        </b-card>
      </div>
    </div>
  </div></template>

<script>
import {
  BCard,
  BCol,
  BFormGroup,
  BRow,
  BTable,
  VBModal,
  BOverlay,
  BPagination,
} from 'bootstrap-vue'
import Filter from '@core/mixins/filter'
import SuccessMessage from '@core/mixins/SuccessMessage'
import ErrorMessage from '@core/mixins/ErrorMessage'
import vSelect from 'vue-select'
import AdvancedDateFilter from '@/components/AdvancedDateFilter/AdvancedDateFilter.vue'
import { RepositoryFactory } from '@/repository/RepositoryFactory'
import FilterButtons from '@/components/Filter/ReportFilterButtons.vue'
import FilterCard from '@/components/FilterCard/FilterCard.vue'
import tableMixin from '@core/mixins/tableMixin'
import getRiderList from './RiderListDropdown'
import { Tablefields } from './TableFields'

const ReportRepository = RepositoryFactory.get('report')

export default {
  directives: {
    'b-modal': VBModal,

  },
  components: {
    vSelect,
    AdvancedDateFilter,
    BCard,
    BTable,
    BRow,
    BCol,
    BFormGroup,
    BOverlay,
    BPagination,
    FilterButtons,
    FilterCard,
  },
  mixins: [Filter, SuccessMessage, ErrorMessage, tableMixin],
  data() {
    return {
      riderOptions: [],
      filters: {
        'order_status_key_5.created_at': {
          startDate: null,
          endDate: null,
        },
      },
      tableData: [],
      sort: '',
      perPage: 20,
      pageOptions: [10, 20, 50, 100, 200],
      totalRows: 1,
      page: 1,
      meta: {},
      sortBy: '',
      sortDesc: false,
      dataLoading: false,
      sortDirection: 'asc',
      filter: null,
      filterOn: [],
      fields: Tablefields,
      json_fields: {
        'Assigned Date': {
          field: 'assign_date',
          // eslint-disable-next-line no-underscore-dangle
          callback: value => this.__dateTimeFormatter(value),
        },
        'Waybill Number': 'waybill_number',
        Merchant: {
          field: 'merchant_name',
          callback: value => `"${value}"`,
        },
        'Customer Name': {
          field: 'customer_name',
          callback: value => `"${value}"`,
        },
        'Customer Email': {
          field: 'customer_email',
          callback: value => `"${value}"`,
        },
        'Customer Address': {
          field: 'customer_address',
          callback: value => `"${value}"`, // Wrap the address in double quotes
        },
        'Customer Phone': 'customer_phone',
        'Second Phone Number': 'customer_secondary_phone',
        COD: 'cod_value',
        Rider: {
          field: 'rider',
          callback: value => `"${value}"`,
        },
        'Rider Employee Id': {
          callback: value => `"${value.rider_employee_id !== null ? `${value.rider_employee_id}` : 'N/A'}"`,
        },
      },
      currentDate: '',
      todayFilterQuery: '',
      downloadReportName: 'Assign-Order-Pickup-Rider',
      items: [],
    }
  },
  computed: {
    sortOptions() {
      // Create an options list from our fields
      return this.fields
        .filter(f => f.sortable)
        .map(f => ({ text: f.label, value: f.key }))
    },
  },
  watch: {
    options: {
      handler() {
        this.fetchAssignOrderPickupRider()
      },
    },
    deep: true,
    page() {
      this.fetchAssignOrderPickupRider()
    },
    perPage() {
      this.fetchAssignOrderPickupRider()
    },
  },
  mounted() {
    // Set the initial number of items
    this.totalRows = this.items.length
    this.setTodayFilter()
    this.fetchAssignOrderPickupRider()
    this.riderList()
    this.updateFilterCount()
  },
  methods: {
    async fetchAssignOrderPickupRider() {
      this.dataLoading = true
      this.items = []
      const filterQuery = this.buildFilterQuery()
      try {
        const { data } = (await ReportRepository.getAssignOrderPickupRiderReport(this.page, filterQuery, this.perPage))
        // fiter the default date or selected date for table data and meta data
        this.items = data.data
        this.meta = data.meta
      } catch (e) {
        this.convertAndNotifyError(e)
      }
      this.dataLoading = false
    },
    async fetchAssignOrderPickupRiderNoPagination() {
      try {
        const filterQuery = this.buildFilterQuery()
        const { data } = (await ReportRepository.getAssignOrderPickupRiderReportNoPagiantion(filterQuery))
        return data.data
      } catch (e) {
        this.convertAndNotifyError(e)
        return []
      }
    },
    async downloadQueueExcel() {
      try {
        // eslint-disable-next-line no-underscore-dangle
        this.__showJsonDownloadAlertForAllOrders()
        const filterQuery = this.buildFilterQuery()
        await ReportRepository.queueAssignedOrdersExcelDownload('pickup_rider', filterQuery)
      } catch (e) {
        this.convertAndNotifyError(e)
      }
    },
    async riderList() {
      this.riderOptions = await getRiderList()
    },
    handleChangePage(page) {
      this.page = page
      this.fetchAssignOrderPickupRider()
    },
    setTodayFilter() {
      const currentDate = this.todayFilter()
      this.updateDateRange('order_status_key_5.created_at', currentDate)
    },
    applyFilters() {
      this.fetchAssignOrderPickupRider()
      this.updateFilterCount()
    },
    clearFilters() {
      this.filters = {
        'order_status_key_5.created_at': {
          startDate: null,
          endDate: null,
        },
      }
      this.setTodayFilter()
      this.$nextTick(() => {
        this.fetchAssignOrderPickupRider()
      })
      this.updateFilterCount()
    },
  },
}
</script>
<style lang="scss">
@import '../../../@core/scss/vue/libs/vue-select';
</style>
